export const normalizedStr = (str: string | undefined) => str?.normalize('NFKC');